<template>
    <v-expansion-panel v-model="panel">
        <v-expansion-panel-header class="mt-2">
            Gestionar negocios
            <template v-slot:actions>
                <v-btn class="mr-5" @click.native.stop="reloadp++" icon small>
                    <v-icon color="primary">mdi-reload</v-icon>
                </v-btn>
                <v-btn @click="$store.dispatch('deleteWindowByUuid',{uuid : win.uuid})" icon small>
                    <v-icon color="error">mdi-close</v-icon>
                </v-btn>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-card>
                <v-tabs
                        v-model="tab"
                        dark background-color="primary"
                        icons-and-text
                >
                    <v-tabs-slider  color="red"></v-tabs-slider>

                    <v-tab v-if="!isRestrictedDteTemplateMode && (roleuser == 'ROLE_ADMIN' || roleuser == 'ROLE_ROOT')" href="#tab-1">
                        Gestión del Negocio
                        <v-icon>mdi-store</v-icon>
                    </v-tab>

                    <v-tab v-if="showBranchesTab" href="#tab-2">
                        Gestión de Sucursales
                        <v-icon>mdi-pencil-circle</v-icon>
                    </v-tab>

                    <v-tab v-if="!isRestrictedDteTemplateMode && (roleuser == 'ROLE_ADMIN' || roleuser == 'ROLE_ROOT') && TipoPlan != 'Contabilidad'"  href="#tab-3">
                        Configuraciones del Negocio
                        <v-icon>mdi-store-cog</v-icon>
                    </v-tab>

                    <v-tab v-if="!isRestrictedDteTemplateMode && (roleuser == 'ROLE_ADMIN' || roleuser == 'ROLE_ROOT') && TipoPlan != 'Contabilidad'" href="#tab-5">
                        Configuración inicial de la sucursal
                        <v-icon>mdi-shield-key</v-icon>
                    </v-tab>

                    <v-tab v-if="!isRestrictedDteTemplateMode && AccountingModule === 1 && TipoPlan != 'Emprendedor' && TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE'" href="#tab-4">
                        Catálogo de cuentas
                        <v-icon>mdi-book-edit</v-icon>
                    </v-tab>

                    <v-tab v-if="!isRestrictedDteTemplateMode && business && business.UsePrinters === 1" href="#tab-6">
                        Impresoras
                        <v-icon>mdi-printer</v-icon>
                    </v-tab>

                    <v-tab v-if="!isRestrictedDteTemplateMode && showTestDteTab && (roleuser == 'ROLE_ADMIN' || roleuser == 'ROLE_ROOT')" href="#tab-7">
                        Pruebas DTE
                        <v-icon>mdi-file-send</v-icon>
                    </v-tab>

                    <v-tab v-if="showApiKeysTab" href="#tab-8">
                        API Keys Facturación
                        <v-icon>mdi-key</v-icon>
                    </v-tab>

                    <v-tab v-if="showExternalProductImagesTab" href="#tab-9">
                        Imágenes de productos
                        <v-icon>mdi-image-multiple</v-icon>
                    </v-tab>

                    <v-tab v-if="showExternalStoreSyncTab" href="#tab-10">
                        Tienda en línea
                        <v-icon>mdi-cart</v-icon>
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab" touchless>
                    <v-tab-item
                            value="tab-1"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <ManageBusiness :key="reloadp" :business="business" :win="win"></ManageBusiness>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                            value="tab-2"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1 py-0">
                                <ManageBranches
                                    :key="reloadp"
                                    :business="business"
                                    :win="win"
                                    :dte-template-mode="isDteTemplateMode"
                                ></ManageBranches>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    
                    <v-tab-item
                            value="tab-3"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <ManageStore :key="reloadp" :business="business" :win="win"></ManageStore>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                    value="tab-4"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <AccountingLedger :key="reloadp"></AccountingLedger>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                            value="tab-5"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <BusinessInitialSetup :key="reloadp" :business="business" :win="win" @close-request="tab = 'tab-3'"></BusinessInitialSetup>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                            value="tab-6"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <Printers :business="business" :win="win"></Printers>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                            v-if="showTestDteTab && (roleuser == 'ROLE_ADMIN' || roleuser == 'ROLE_ROOT')"
                            value="tab-7"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <TestDteSender :business="business"></TestDteSender>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                            v-if="showApiKeysTab"
                            value="tab-8"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <ManageApiKeys :key="reloadp" :business="business" :win="win"></ManageApiKeys>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                            v-if="showExternalProductImagesTab"
                            value="tab-9"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <ManageExternalProductImagesCredentials :key="reloadp" />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item
                            v-if="showExternalStoreSyncTab"
                            value="tab-10"
                    >
                        <v-card flat>
                            <v-card-text class="pa-1">
                                <ManageExternalStoreSync :key="reloadp" />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import ManageBranches from './partial/ManageBranches';
import ManageBusiness from './partial/ManageBusiness';
import ManageStore from './partial/ManageStore';
import AccountingLedger from './partial/AccountingLedger';
import Printers from './partial/Printers';
import TestDteSender from './components/TestDteSender';
import ManageApiKeys from './partial/ManageApiKeys';
import ManageExternalProductImagesCredentials from './partial/ManageExternalProductImagesCredentials';
import ManageExternalStoreSync from './partial/ManageExternalStoreSync';
import BusinessInitialSetup from './partial/BusinessInitialSetup';

export default {
    name: "Business",
    components: {
        ManageBranches,ManageBusiness,ManageStore, AccountingLedger, Printers, TestDteSender, ManageApiKeys, ManageExternalProductImagesCredentials, ManageExternalStoreSync, BusinessInitialSetup
    },
    props: ['win'],
    data () {
        return {
            tab: null,
            panel: 0,
            business: null,
            reloadp: 0,
            AccountingModule: JSON.parse(localStorage.getItem("user")).AccountingModule,
            TipoPlan: JSON.parse(localStorage.getItem("user")).TipoPlan,
            ApiKeyFeature: JSON.parse(localStorage.getItem("user")).apikeyfeature,
            externalProductImagesAccess: {
                enabled: false,
                canManageCredentials: false,
                canManageImages: false,
                canViewHistory: false
            }
        }
    },
    mounted() {
        this.refreshBusiness();
        this.tab = this.isDteTemplateMode ? "tab-2" : this.win.meta.tab;

        if (!this.showTestDteTab && this.tab === "tab-7") {
            this.tab = "tab-1";
        }

        if (!this.showApiKeysTab && this.tab === "tab-8") {
            this.tab = "tab-1";
        }

        this.loadExternalProductImagesAccess();

        if (!this.showInitialSetupTab && this.tab === "tab-5") {
            this.tab = "tab-1";
        }

        if (this.isRestrictedDteTemplateMode) {
            this.tab = "tab-2";
        }
    },
    computed:{
        roleuser(){
            return JSON.parse(localStorage.getItem("user")).roles[0]
        },
        isAdminUser() {
            return this.roleuser == 'ROLE_ADMIN' || this.roleuser == 'ROLE_ROOT';
        },
        isDteTemplateMode() {
            return !!this.win?.meta?.dteTemplateMode;
        },
        isRestrictedDteTemplateMode() {
            return this.isDteTemplateMode && !this.isAdminUser;
        },
        showBranchesTab() {
            return this.isDteTemplateMode || (this.isAdminUser && this.TipoPlan != 'Contabilidad');
        },
        showApiKeysTab() {
            return !this.isRestrictedDteTemplateMode && this.isAdminUser && Number(this.ApiKeyFeature) === 1;
        },
        showExternalProductImagesTab() {
            return !this.isRestrictedDteTemplateMode && this.externalProductImagesAccess.enabled && this.externalProductImagesAccess.canManageCredentials;
        },
        showExternalStoreSyncTab() {
            const sessionBusinessId = JSON.parse(localStorage.getItem("user"))?.businessid;
            return !this.isRestrictedDteTemplateMode && this.isAdminUser
                && String(this.business?.ID_Business) === String(sessionBusinessId)
                && Number(this.business?.ExternalStoreSyncFeature) === 1;
        },
        showInitialSetupTab() {
            return !this.isRestrictedDteTemplateMode && this.isAdminUser && this.TipoPlan != 'Contabilidad';
        },
        showTestDteTab() {
            const faMh = JSON.parse(localStorage.getItem("FaMh"));
            const branch = JSON.parse(localStorage.getItem("branch"));

            return Number(faMh?.AuthFeActive) === 1 && Number(branch?.AuthFeMode) === 0;
        }
    },
    methods: {
        async refreshBusiness() {
            const businessId = this.win?.meta?.business?.ID_Business || null;

            if (!businessId) {
                this.business = this.win?.meta?.business || null;
                return;
            }

            try {
                const freshBusiness = await this.$API.business.FindOne(businessId);
                this.business = freshBusiness || this.win?.meta?.business || null;
                if (this.win?.meta) {
                    this.$set(this.win.meta, "business", this.business);
                }
            } catch (error) {
                this.business = this.win?.meta?.business || null;
            }
        },
        async loadExternalProductImagesAccess() {
            try {
                const response = await this.$API.externalProductImages.getAccess();
                this.externalProductImagesAccess = response.data || this.externalProductImagesAccess;
                if (!this.showExternalProductImagesTab && this.tab === "tab-9") {
                    this.tab = "tab-1";
                }
            } catch (error) {
                this.externalProductImagesAccess = {
                    enabled: false,
                    canManageCredentials: false,
                    canManageImages: false,
                    canViewHistory: false
                };
            }
        }
    }
}
</script>

<style scoped>
.sidebar-options{
    display: none;
}

</style>
